<script lang="ts">
	import { copyToClipboard } from '#lib/helper/copyCliboard.js';
	import { t } from '#lib/stores/i18n.js';
	import { toastSuccess } from '#lib/stores/toast.js';
	import type { Snippet } from 'svelte';

	interface Props {
		className?: string;
		preClasses?: string;
		disableCopy?: boolean;
		hideBorders?: boolean;
		children?: Snippet;
	}

	let {
		className = '',
		preClasses = 'text-xs',
		disableCopy = false,
		hideBorders = false,
		children
	}: Props = $props();

	let extendPre = $state(false);

	function click() {
		extendPre = !extendPre;

		if (!disableCopy && thisElt) {
			copyToClipboard(thisElt);

			// Show a message to the user
			toastSuccess($t('clipboard.copied'));
		}
	}

	let thisElt = $state<HTMLPreElement>();
</script>

<div
	class="text-left rounded-md {!hideBorders
		? 'border border-border dark:border-border-dark'
		: ''} w-full p-2 cursor-pointer {className}"
	onclickcapture={(e) => {
		e.stopPropagation();
		click();
	}}
	role="presentation"
>
	<pre
		class="{extendPre ? 'max-h-96 overflow-auto' : 'truncate'} {preClasses}"
		bind:this={thisElt}>{@render children?.()}</pre>
</div>
